/**
 * Orders API
 * Orders API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';


class PermissionEdit {
    
    constructor(userId, roles) { 
        
        PermissionEdit.initialize(this, userId, roles);
    }

    
    static initialize(obj, userId, roles) { 
        obj['userId'] = userId;
        obj['roles'] = roles;
    }

    
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PermissionEdit();

            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'String');
            }
            if (data.hasOwnProperty('roles')) {
                obj['roles'] = ApiClient.convertToType(data['roles'], ['String']);
            }
        }
        return obj;
    }


}


PermissionEdit.prototype['userId'] = undefined;


PermissionEdit.prototype['roles'] = undefined;






PermissionEdit['RolesEnum'] = {

    
    "owner": "owner",

    
    "canRead": "canRead",

    
    "canWrite": "canWrite",

    
    "viewer": "viewer",

    
    "performer": "performer"
};



export default PermissionEdit;

